import React from 'react'
import Image from 'next/image'
import { Header2, Text } from '../../styles/Components'
import { gsColors } from '../../styles/Variables'
import Button from '../Button'
import Pro1Image from '../../../public/about-us/pro-1.jpg'
import Pro2Image from '../../../public/about-us/pro-2.jpg'
import { TopTierTalentWrapper } from './styles'

const pros = [
  {
    id: 'johnny',
    name: 'Johnny Wright',
    role: 'Textured Hair Advisor & Celebrity Stylist',
    blurb: 'Textured hair specialist, Johnny Wright, supports our pros with his 30+ years of knowledge—providing deep, expert education on how to care for and style textured hair.',
    image: Pro1Image,
    alt: 'Celebrity stylist Johnny Wright, Glamsquad textured hair advisor, laughing in a white T-shirt',
  },
  {
    id: 'vetted',
    name: 'Vetted pros across the US',
    role: 'Hair Stylists, Makeup Artists & Nail Techs',
    blurb: 'Our trusted beauty professionals are the best in the business. Each pro is extensively educated in their craft with expertise ranging from red carpets and runways to editorial pages and celebrity clients.',
    image: Pro2Image,
    alt: 'A group of vetted Glamsquad hair stylists, makeup artists and nail techs posing together and smiling',
  },
]

const TopTierTalent = () => (
  <TopTierTalentWrapper aria-label="Top tier talent">
    <Header2 className="section-heading">Top tier talent</Header2>
    <div className="talent-grid">
      {pros.map((p) => (
        <div className="talent-item" key={p.id}>
          <div className="talent-copy">
            <p className="talent-name">{p.name}</p>
            <p className="talent-role">{p.role}</p>
            <Text fontSize={16} lineHeight="1.3" spacing={0.16}>{p.blurb}</Text>
          </div>
          <div className="talent-image">
            <Image
              src={p.image}
              alt={p.alt}
              fill
              style={{ objectFit: 'cover' }}
              sizes="(max-width: 768px) 100vw, 50vw"
            />
          </div>
        </div>
      ))}
    </div>
    <div className="cta-block">
      <Header2 fontSize={32} lineHeight="1.2" align="center" margin="0">
        Want to work with us?
      </Header2>
      <a
        href="https://apply.glamsquad.com"
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'none' }}
      >
        <Button
          large
          color={gsColors.cobalt}
          padding="14px 40px"
        >
          Become a Pro
        </Button>
      </a>
    </div>
  </TopTierTalentWrapper>
)

export default TopTierTalent
